import * as Yup from "yup";

export const createIndividualInformationInputSchema = Yup.object().shape({
  firstName: Yup.string().required("First name is required").default(""),
  middleName: Yup.string(),
  lastName: Yup.string().required("Last name is required").default(""),
  dateOfBirth: Yup.date()
    .required("Date of birth is required")
    .max(new Date(), "Date of birth must be in the past"),
  identificationNumber: Yup.string()
    .required("Identification number is required")
    .min(4, "Identification number must be at least 4 digits"),
});
